import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";

import Modal from "react-modal";
import moment from "moment";
import { toast } from "react-toastify";

const LotCreationForm = (props) => {
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [prProduct, setPrProduct] = useState();
  const [close, setClose] = useState(false);
  const [units, setUnits] = useState(false);
  const [totalQuantity, setTotalQuantity] = useState();
  const [totalQuantityUnit, setTotalQuantityUnit] = useState();
  const { sendRequest: postLotCreation } = useHttp();

  const { sendRequest: getEmp } = useHttp();
  const [employeeId, setEmployeeId] = useState([]);

  const [loading, setLoading] = useState(false);

  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeeId(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getProcurementReciept } = useHttp();

  const [prData, setPrData] = useState();

  useEffect(() => {
    getProcurementReciept(
      {
        url: `/api/getProcurementRecieptForLot/?warehouseId=${parseInt(localStorage.getItem("warehouseId"))}`,
      },
      (data) => {
        // //console.log(data.ProcurementReciept);
        setPrData(data.ProcurementReciept);
      }
    );
  }, [getProcurementReciept]);

  const { sendRequest: getunits } = useHttp();

  useEffect(() => {
    getunits(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          setUnits(res);
          // //console.log(res);
        }
      }
    );
  }, [getunits]);

  const submitHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    const totalAmount = productDetails.reduce(
      (acc, item) => acc + parseFloat(item.amount || 0),
      0
    );
    //console.log(totalAmount);
    const data = {
      lotDate: moment(frmRef.current.lot_created_date.value).format(
        "DD/MM/YYYY"
      ),
      SupervisorEmployeeId: frmRef.current.emp_id.value,
      productDetails: productDetails,
      lotQuantity: frmRef.current.lot_quantity.value,
      // unitId: frmRef.current.unit.value,
      unitId: 2,
      lotAmount: totalAmount,
      mrlStatus: "test",
      status: 1,
      productDetails: productDetails,
      remark: frmRef.current.remark.value,
      createdBy: parseInt(localStorage.getItem("id")),
      createdDate: dateString,
      orgId: localStorage.getItem("orgId"),
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      serviceId: props.sId,
    };
    if (props.update) {
      data["lotId"] = props.update.lotId;
    }

    //console.log(data);

    postLotCreation(
      {
        url: "/api/lotCreation/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success("Lot Created");
        props.addForm(false);
        setLoading(false);
      },(error) => {
       
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    // //console.log(props.update);
    if (props.update) {
      frmRef.current.lot_created_date.value = props.update.lotDate
        .split("/")
        .reverse()
        .join("-");

      frmRef.current.emp_id.value = props.update.SupervisorEmployeeId;
      setProductDetails(props.update.productDetails);
      frmRef.current.lot_quantity.value = props.update.lotQuantity;
      frmRef.current.unit.value = props.update.unitAbbreviation;
      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);

  // product details modal
  const submitProduct = (e) => {
    e.preventDefault();

    const selectedReceiptId =
      productRef.current["procurement_receipt_id"].value;

    //// //console.log(productDetails);

    const isDuplicate = productDetails.some(
      (item) => item.procurementRecieptId == selectedReceiptId
    );
    //console.log(isDuplicate);
    if (isDuplicate) {
      toast.warn("Data already exist");
    } else {
      //// //console.log(prProduct);
      var farmerName = productRef.current.farmer_name.value;

      const filterdData =
        prData &&
        prData.filter(
          (item) =>
            parseInt(item.procurementRecieptId) ===
            parseInt(productRef.current.procurement_receipt_id.value)
        );
      //// //console.log("prData", prData[0]);

      const updatedProductDetails = prProduct.map((product) => ({
        procurementProductRecieptId: product.procurementProductRecieptId,
        procurementRecieptId: product.procurementRecieptId,
        procurementRecieptNo: product.procurementRecieptNo,
        farmerName: farmerName,
        cropName: product.cropName,
        productName: product.productName,
        productId: product.productId,
        varietyName: product.varietyName,
        itemQuantity: product.itemQuantity,
        unitAbbreviation: product.unitAbbreviation,
        unit: product.unit,
        unitId: product.unitId,
        rate: product.rate,
        amount: parseFloat(product.itemQuantity) * parseFloat(product.rate),
        gradeId: product.gradeId,
        remark: product.remark,
        status: product.status,
        createdDate: product.createdDate,
        gatepassdetailId: product.gatepassdetailId,
        orgId: product.orgId,
        createdBy: product.createdBy,
        createdDate: dateString,
        farmerDetail: {
          farmerName: farmerName,
          cropPlotId: prData[0].cropPlotId || 0,
        },
      }));

   

      const updatedDetails = [...productDetails, ...updatedProductDetails];

      console.log(updatedDetails);
      setProductDetails(updatedDetails);

      productRef.current.procurement_receipt_id.value = "";

      //productRef.current.farmer_id.value = "";
      productRef.current.farmer_name.value = "";
      setPrProduct("");
    }
  };

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const LoadPrProductList = (data, e) => {
    // //console.log(data);
    e.preventDefault();
  };

  const handleReceiptIdChange = (e) => {
    // //console.log(e.target.value);
    const id = e.target.value;
    setPrProduct();
    loadPrProduct(id);
    const filterdData =
      prData &&
      prData.filter(
        (item) => parseInt(item.procurementRecieptId) === parseInt(id)
      );

    // //console.log(filterdData[0]);

    //  productRef.current.farmer_id.value = filterdData[0].farmerId;
    productRef.current.farmer_name.value = filterdData[0].farmerName;
  };

  const { sendRequest: getPrProduct } = useHttp();

  const loadPrProduct = (id) => {
    getPrProduct(
      {
        url: `/api/getProcurementRecieptProductForLot/?procurementRecieptId=${id}`,
      },
      (res) => {
        // //console.log(res.ProcurementReciept);

        //LoadPrProductList(res.ProcurementReciept);
        setPrProduct(res.ProcurementReciept);
      }
    );
  };

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "900px",
      maxHeight: "600px",
      height: "auto",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };

  return (
    <>
      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row ">
            <div className="col-md-3">
              <label htmlFor={"procurement_receipt_id"}>
                Procurement Receipt id
              </label>

              <select
                id={"procurement_receipt_id"}
                className="form-control"
                onChange={handleReceiptIdChange}
                ref={(el) =>
                  (productRef.current["procurement_receipt_id"] = el)
                }
              >
                <option value="">Select</option>
                {prData &&
                  prData.map((x, i) => (
                    <option key={i} value={x.procurementRecieptId}>
                      {x.procurementRecieptNo}
                    </option>
                  ))}
              </select>
            </div>

            <div className="col-md-3">
              <label htmlFor={"farmer_id"}>Farmer Name</label>
              <input
                type={"text"}
                id={"farmer_name"}
                required
                disabled
                ref={(el) => (productRef.current["farmer_name"] = el)}
                className="form-control"
              />
            </div>
          </div>
          <br />
          <div>
            <table className="table table-bordered table-sm">
              <thead>
                <tr className="">
                  <th>Sr. No</th>
                  <th>Crop</th>
                  <th>Variety</th>

                  <th>Grade</th>
                  <th>Product Name </th>

                  <th>Item Quantity</th>
                  <th>Rate</th>
                  <th>Amount</th>
                  <th>Unit</th>
                  {/* <th>MRL Status</th> */}
                  {/* <th>Delete</th> */}
                </tr>
              </thead>
              <tbody>
                {prProduct &&
                  prProduct.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.cropName}</td>
                        <td>{itm.varietyName}</td>
                        <td>{itm.gradeName}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.itemQuantity}</td>
                        <td>{itm.rate}</td>
                        <td>
                          {parseFloat(itm.itemQuantity) * parseFloat(itm.rate)}
                        </td>
                        <td>{itm.unitAbbreviation}</td>
                        {/* <td></td> */}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div>
            {" "}
            <div className="">
              <button
                className="btn btn-sm btn-success"
                onClick={submitProduct}
              >
                Add
              </button>
            </div>
          </div>

          <hr />
          <div className="">
            <table className="table table-responsive table-sm table-bordered">
              <thead>
                <tr className="">
                  <th>Sr. No</th>
                  {/* <th>Item Id</th> */}

                  <th>Procurement Receipt No</th>
                  <th>Farmer Name</th>
                  <th>Item Type</th>
                  <th>Item Category/Variety</th>

                  <th>Item Description</th>
                  <th>Grade</th>

                  <th>Item Quantity</th>
                  <th>Rate</th>
                  <th>amount</th>
                  <th>Unit</th>
                  {/* <th>MRL Status</th> */}
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {productDetails &&
                  productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.procurementRecieptNo}</td>
                        <td>{itm.farmerName}</td>
                        <td>{itm.cropName}</td>
                        <td>{itm.varietyName}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.gradeName}</td>

                        <td>{itm.itemQuantity}</td>
                        <td>{itm.rate}</td>

                        <td>{itm.amount}</td>
                        <td>{itm.unitAbbreviation}</td>
                        {/* <td></td> */}

                        <td>
                          <button
                            className="btn"
                            onClick={(e) => handleDelete(i, e)}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div className="text-center">
            <br />
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                // productDetails &&
                //   productDetails.map((x) => (x["isSave"] = true));

                if (productDetails && productDetails.length > 0) {
                  let totalQuantity = 0;
                  productDetails.forEach((x) => {
                    if (x.itemQuantity) {
                      totalQuantity += parseFloat(x.itemQuantity);
                    }
                    x.isSave = true;
                  });
                  setTotalQuantity(totalQuantity);
                  setTotalQuantityUnit("Kg");
                  setClose(false);
                  setPrProduct("");
                }
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">&nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Lot Creation Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"lot_created_date"}>
                        {"Lot Created Date "}
                      </label>
                      <input
                        type={"date"}
                        id={"lot_created_date"}
                        required
                        ref={(el) => (frmRef.current["lot_created_date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={
                          props.update
                            ? props.update.lotDate
                                .split("/")
                                .reverse()
                                .join("-")
                            : selectedDate
                        }
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"emp_id"}>{"Assigned Supervisor"}</label>
                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                      >
                        {employeeId &&
                          employeeId.map((x, i) => (
                            <option
                              value={x.empId}
                              selected={
                                props.update &&
                                props.update.SupervisorEmployeeId == x.empId
                              }
                              key={i}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        onClick={() => {
                          productDetails &&
                            setProductDetails((items) =>
                              items.filter(
                                (x) => x.isSave || x.procurementRecieptId
                              )
                            );
                          setClose(true);
                          setPrProduct("");
                        }}
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"lot_quantity"}>{"Lot Quantity "}</label>
                      <input
                        type={"text"}
                        id={"lot_quantity"}
                        required
                        ref={(el) => (frmRef.current["lot_quantity"] = el)}
                        className="form-control"
                        value={totalQuantity}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"unit"}>{"Unit"}</label>

                      <input
                        type={"text"}
                        id={"unit"}
                        required
                        value={totalQuantityUnit}
                        ref={(el) => (frmRef.current["unit"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2"></div>
                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default LotCreationForm;
